export default class MediaLazyLoad {


    constructor() {
        this.images = document.querySelectorAll('[data-lazy-src]');
        this.styles = document.querySelectorAll('[data-lazy-style]');

        if(this.images.length) {
            this.initLazyImages();
        }

        if(this.styles.length) {
            this.initLazyStyles();
        }
    }

    initLazyImages() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.isIntersecting) {
                    const dataSrc = entry.target.getAttribute('data-lazy-src');
                    entry.target.setAttribute('src', dataSrc);

                    observer.unobserve(entry.target);
                }

            });
        });

        this.images.forEach(image => observer.observe(image));
    }

    initLazyStyles() {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if(entry.isIntersecting) {
                    const dataStyle = entry.target.getAttribute('data-lazy-style');
                    entry.target.setAttribute('style', dataStyle);

                    observer.unobserve(entry.target);
                }

            });
        });

        this.styles.forEach(style => observer.observe(style));
    }

}
